import NPSContainer from './containers/NPSTableContainer';

export default NPSContainer;
